import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownContentProps {
    children: string;
    className?: string;
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({ children, className = '' }) => (
    <div className={`prose prose-gray prose-sm sm:prose-base max-w-none
        prose-headings:text-gray-900 prose-headings:font-bold
        prose-p:text-gray-700 prose-p:leading-relaxed
        prose-strong:text-gray-900
        prose-ul:text-gray-700 prose-ol:text-gray-700
        prose-li:marker:text-[#1A4D4F]
        prose-a:text-[#1A4D4F] prose-a:underline hover:prose-a:text-[#1A4D4F]
        ${className}`}
    >
        <ReactMarkdown>{children}</ReactMarkdown>
    </div>
);
